import React, { Component } from "react";
import { Accordion } from "semantic-ui-react";
import _ from "lodash";

class CriminalRecordsSecondarySection extends Component {
  constructor(props) {
    super(props);
    const additionalData = _.cloneDeep(this.props.additionalData);
    additionalData.requestedSection = "common";
    this.state = {
      activeIndex: 0,
    };
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    return (
      <Accordion fluid styled>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`CrimSecTitle`}
          onClick={() => this.handleClick()}
        >
          <p>
            Criminal Records Involving Subject - Secondary Sources
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`CrimSecBody`}
          active={this.state.activeIndex === 0}
        >
          No Records Found
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default CriminalRecordsSecondarySection;



// WEBPACK FOOTER //
// ./src/components/reports/CriminalRecordsSecondarySection.js